<template>
  <div>
    <div class="flex items-start space-x-6">
      <aside
        class="
          border border-grey-500
          rounded
          max-w-xs
          w-full
          divide-y divide-grey-500
        "
      >
        <accordion-item v-if="showPublishers" class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium">
              Publishers
            </span>
          </template>
          <template :slot="'content'">
            <select-input placeholder="Find Publishers" />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium"> Imprint </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium"> Category </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium">
              Publication Date
            </span>
          </template>
          <template :slot="'content'">
            <t-datepicker
              :monthsPerView="2"
              :multiple="true"
              :range="true"
              :weekStart="1"
              placeholder="Choose date or period"
              dateFormat="F j, Y"
            />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium"> Price </span>
          </template>
          <template :slot="'content'">
            <div
              class="
                flex
                divide-x divide-grey-500
                border border-grey-500
                rounded
                overflow-hidden
                mb-5
              "
            >
              <div class="flex items-center px-3 py-2">
                <label
                  class="text-base text-black-900 mr-2"
                  for="rangeInputMin"
                >
                  SGD
                </label>
                <input
                  :value="value[0]"
                  id="rangeInputMin"
                  class="
                    w-full
                    text-base text-black-900
                    placeholder:text-grey-700
                    hide-arrows
                  "
                  type="number"
                  placeholder="From"
                  :min="minValue"
                  @blur="checkMinRangeInput"
                  @keydown.enter="checkMinRangeInput"
                />
              </div>
              <div class="flex items-center px-3 py-2">
                <label
                  class="text-base text-black-900 mr-2"
                  for="rangeInputMax"
                >
                  SGD
                </label>
                <input
                  :value="value[1]"
                  id="rangeInputMax"
                  class="
                    w-full
                    text-base text-black-900
                    placeholder:text-grey-700
                    hide-arrows
                  "
                  type="number"
                  placeholder="To"
                  min="0"
                  @blur="checkMaxRangeInput"
                  @keydown.enter="checkMaxRangeInput"
                />
              </div>
            </div>

            <div>
              <vue-slider
                v-model="value"
                :dotSize="16"
                :height="2"
                :min-range="1"
                tooltip="hover"
                :tooltip-placement="'bottom'"
              ></vue-slider>
            </div>

            <base-button>
              <svg
                class="mr-2"
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 5.8L5.21053 9L11 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Apply
            </base-button>
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium">
              Availability
            </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium"> Format </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium">
              Target Audience
            </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
        <accordion-item class="relative px-4 py-3">
          <template :slot="'title'">
            <span class="text-base text-black-900 font-medium"> Language </span>
          </template>
          <template :slot="'content'">
            <checkbox-field />
          </template>
        </accordion-item>
      </aside>
      <main class="flex-1">
        <div class="grid grid-cols-2 gap-3">
          <card-book
            v-for="book in booksArray"
            :key="book.id"
            :bookData="book"
            @open-modal="openModal(book)"
            @export-to-pdf="exportToPdf"
          ></card-book>
        </div>

        <base-button class="mt-9">
          <svg
            class="mr-2"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 1V11M11 6L1 6"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
          Show more 24
        </base-button>
      </main>
    </div>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      filename="Catalog"
      :manual-pagination="true"
      pdf-content-width="775px"
      ref="html2Pdf"
      :html-to-pdf-options="htmlToPdfOptions"
    >
      <book-detail-pdf slot="pdf-content" :bookData="modal.data" />
    </vue-html2pdf>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import VueHtml2pdf from "vue-html2pdf";

import BookDetailPdf from "@/components/pdf/BookDetail.vue";
import CardBook from "@/components/cards/CardBook.vue";

export default {
  name: "TabBooks",
  components: {
    VueSlider,
    VueHtml2pdf,
    "book-detail-pdf": BookDetailPdf,
    "card-book": CardBook,
    "base-button": () => import("@/components/utils/Button.vue"),
    "select-input": () => import("@/components/utils/SelectInput.vue"),
    "accordion-item": () => import("@/components/utils/AccordionItem.vue"),
    "checkbox-field": () => import("@/components/utils/CheckboxField.vue"),
  },
  props: {
    showPublishers: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      htmlToPdfOptions: {
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 5,
        },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
      booksArray: [
        {
          id: 1,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/1.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: false,
          price: 12.0,
        },
        {
          id: 2,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/2.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 3,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/3.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: false,
          price: 12.0,
        },
        {
          id: 4,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/4.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 5,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/5.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 6,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/6.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 7,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/7.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
      ],
      value: [0, 100],
      minValue: 0,
      maxValue: 100,
      modal: {
        data: {},
      },
    };
  },
  methods: {
    async openModal(bookData) {
      this.$modal.show("book-modal", { ...bookData });
    },
    exportToPdf(bookData) {
      this.modal.data = { ...bookData };

      this.$refs.html2Pdf.generatePdf();
    },
    checkMinRangeInput(event) {
      const newValue = +event.target.value;
      if (newValue >= this.value[1]) {
        this.$set(this.value, 0, this.value[1] - 1);
        return;
      }
      if (newValue < this.minValue) {
        this.$set(this.value, 0, this.minValue);
        return;
      }
      this.$set(this.value, 0, newValue);
    },
    checkMaxRangeInput(event) {
      const newValue = +event.target.value;
      if (newValue > this.maxValue) {
        this.$set(this.value, 1, this.maxValue);
        return;
      }
      if (newValue <= this.minValue || newValue <= this.value[0]) {
        this.$set(this.value, 1, this.value[0] + 1);
        return;
      }
      this.$set(this.value, 1, newValue);
    },
  },
};
</script>
